module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('NbExpanding', [_c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "lobby-theme-menu-list"
  }, [_c('div', {}, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.menus), function(menu) {
    return _c('li', {
      class: {
        active: menu.active
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.menuClick(menu)
        }
      }
    }, [_c('span', {
      staticClass: "nav-label"
    }, [_vm._v(_vm._s(menu.name))]), _vm._v(" "), (menu.isParent()) ? _c('i', {
      staticClass: "pull-right fa",
      class: {
        'fa-angle-left': !menu.active, 'fa-angle-down': menu.active
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          menu.active = !menu.active;
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('NbExpanding', [(menu.menus && menu.menus.length) ? _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (menu.active),
        expression: "menu.active"
      }],
      staticClass: "nav nav-second-level"
    }, _vm._l((menu.menus), function(menu1, index1) {
      return _c('li', {
        class: {
          active: menu1.active
        }
      }, [_c('a', {
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.menuClick(menu1)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(menu1.name) + "\n\t\t\t\t\t\t\t\t")])])
    }), 0) : _vm._e()])], 1)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1166c5e9"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/theme/widget/MenuListView.vue
// module id = 950
// module chunks = 1